import { connect, MapStateToProps } from 'react-redux';
import { Props } from './MobileHeroCard';
import {
  getCurrentCoreSubscription,
  getPackages,
  getPackageConfig,
  getPickerMode,
  getSale,
} from '../../../../../redux/packagePicker/selectors';
import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession/selectors';

export type StateProps = Pick<
  Props,
  | 'packages'
  | 'pickerMode'
  | 'alreadyHasSubscription'
  | 'currentCoreSubscription'
  | 'packageConfig'
  | 'sale'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = state => ({
  packages: getPackages(state) || [],
  pickerMode: getPickerMode(state) || 'buy',
  packageConfig: getPackageConfig(state),
  alreadyHasSubscription:
    getPickerMode(state) === 'gift' ? false : getCurrentUserHasCore(state),
  currentCoreSubscription: getCurrentCoreSubscription(state),
  sale: getSale(state),
});

export default connect(mapStateToProps);
